export default {
      id: "info-circle-16-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/iconset.svg#info-circle-16",
      toString: function () {
        return this.url;
      }
    }